var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tms-dashboard" }, [
    _c(
      "div",
      { staticClass: "content-body" },
      [
        _c("div", { staticClass: "nav-bar-container" }, [
          _c("div", { staticClass: "nav-bar clearfix" }, [
            _c("div", { staticClass: "welcome" }, [
              _c("span", { staticClass: "notice-header" }, [
                _vm._v(_vm._s(_vm.$t("userGuideForms.title"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "summary-items" }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "TabsContainer",
          {
            staticClass:
              "tabs-container-wrapper user-guide-and-form-display-panel",
            attrs: { tabNames: _vm.tabNames },
          },
          [
            _c(
              "div",
              { attrs: { slot: "tab-0" }, slot: "tab-0" },
              _vm._l(_vm.guideGroups, function (files, groupName) {
                return _c(
                  "Collapse",
                  {
                    key: groupName,
                    staticClass: "guide-forms-display-collapse",
                    attrs: { expand: true },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "guide-forms-display-collapse-title",
                        attrs: { slot: "title" },
                        slot: "title",
                      },
                      [_vm._v(_vm._s(_vm.groupTypesName[groupName]))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("CommonTable", {
                          staticClass: "guide-forms-display",
                          attrs: {
                            tableContentLists: files,
                            renderHeaderList: _vm.tableHeader,
                            interactionFunc: _vm.interactionFunc,
                            defaultOrderKey: "order",
                            defaultOrder: true,
                            needFilter: false,
                            tableId: "guide-forms-display-" + groupName,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { slot: "tab-1" }, slot: "tab-1" },
              _vm._l(_vm.formsGroups, function (files, groupName) {
                return _c(
                  "Collapse",
                  {
                    key: groupName,
                    staticClass: "guide-forms-display-collapse",
                    attrs: { expand: true },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "guide-forms-display-collapse-title",
                        attrs: { slot: "title" },
                        slot: "title",
                      },
                      [_vm._v(_vm._s(_vm.groupTypesName[groupName]))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("CommonTable", {
                          staticClass: "guide-forms-display",
                          attrs: {
                            tableContentLists: files,
                            renderHeaderList: _vm.tableHeader,
                            interactionFunc: _vm.interactionFunc,
                            defaultOrderKey: "order",
                            defaultOrder: true,
                            needFilter: false,
                            tableId: "guide-forms-display-" + groupName,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }